import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import { getContentTypes } from "../../network/lib/masterData.js";
import { showHideLoader } from "../utils/helper.js";
import {
  goalsObject,
  save,
  update,
  getPreview,
  getLive,
  deleteLive,
  deletePreview,
  publish,
} from "../../network/lib/goals.js";

function Goals({ user }) {
  const [contentTypes, setContentTypes] = useState();
  const [heading, setHeading] = useState("");
  const [textType, setTextType] = useState("1");
  const [content, setContent] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  useEffect(() => {
    !contentTypes && populateContentTypes();
  }, []);

  const populateContentTypes = () => {
    getContentTypes().then((res) => {
      if (res.status == 200) {
        setContentTypes(res.data);
      }
    });
  };

  const setToDefault = () => {
    setHeading("");
    setTextType("1");
    setContent("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setHeading(params.heading);
      setTextType(params.contentTypeId);
      setContent(params.content);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    if (content == "") {
      message.innerHTML = "Please provide Content";
    } else {
      showHideLoader(true);
      goalsObject.id = id;
      goalsObject.heading = heading;
      goalsObject.contentTypeId = textType;
      goalsObject.content = content;
      goalsObject.userName = user.userName;

      if (id == 0) {
        save(goalsObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(goalsObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = () => {
    showHideLoader(true);
    getPreview()
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchPreviewData();
  };

  const fetchLiveData = () => {
    showHideLoader(true);
    getLive()
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    fetchLiveData();
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        goalsObject.id = parseInt(params);
        goalsObject.userName = user.userName;
        deletePreview(goalsObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview."
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        goalsObject.id = parseInt(params);
        goalsObject.userName = user.userName;

        deleteLive(goalsObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      goalsObject.id = parseInt(params);
      goalsObject.userName = user.userName;

      publish(goalsObject).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData();
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Goals Activity
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>Heading</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="107" />
                )}
                value={heading}
                onChangeText={(text) => {
                  setHeading(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Text Type</span>
            </td>
            <td colSpan={3}>
              {contentTypes && (
                <select
                  onChange={(e) => setTextType(e.target.value)}
                  value={textType}
                  style={{ width: "322px" }}
                >
                  {contentTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Content</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="10" cols="107" />
                )}
                value={content}
                onChangeText={(text) => {
                  setContent(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan="3">
              <span>
                Note :- Add Pipe(|) Seperator In Between Every New Point On The
                List Option.
              </span>
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td style={{ textAlign: "right" }}>
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr align="center">
              <th align="center" colSpan={admin ? 6 : approver ? 5 : 4}>
                Preview
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 6 : approver ? 5 : 4}></td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              {publisher && (
                <td style={{ textAlign: "center" }}>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>Heading</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Content Type</u>
              </td>
              <td>
                <u>Content</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Edit</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i + 1} align="center">
                  {publisher && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.heading}</td>
                  <td style={{ textAlign: "center" }}>{x.contentType}</td>
                  <td>{x.content}</td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 6 : approver ? 5 : 4}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 4 : 3}>
                Live
              </th>
            </tr>
            <tr>
              <td colSpan={admin ? 4 : 3}></td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              <td>
                <u>Heading</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Content Type</u>
              </td>
              <td>
                <u>Content</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i + 1} align="center">
                  <td>{x.heading}</td>
                  <td style={{ textAlign: "center" }}>{x.contentType}</td>
                  <td>{x.content}</td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 4 : 3} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default Goals;
